"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _widgetActions = require("./widgetActions");
const initialState = {
  instanceId: '',
  isWidgetLoaded: false,
  isWidgetReady: false
};
const widgetReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _widgetActions.SET_INSTANCE_ID:
      return {
        ...state,
        instanceId: payload.instanceId
      };
    case _widgetActions.SET_WIDGET_LOADED_STATUS:
      return {
        ...state,
        isWidgetLoaded: payload.isWidgetLoaded
      };
    case _widgetActions.SET_WIDGET_READY_STATUS:
      return {
        ...state,
        isWidgetReady: payload.isWidgetReady
      };
    default:
      return state;
  }
};
var _default = widgetReducer;
exports.default = _default;